/**
 * @file header.class.js
 * @description Defines the Header class.
 */

class Header {
  constructor(debug = false) {
    this.elHeader = Helper.getElement('header.header');
    this.elBanner = Helper.getElement('.banner');
    this.elInnerBanner = Helper.getElement('.inner-banner');
    this.viewportWidth = window.innerWidth;
    this.addPlaceholder = Helper.debounce( (event) => { this.addPlaceholderFn(event) }, 300);
    this.init();
    this.debug();
  }

  init() {
    this.bindEvents();
    this.handleStickyHeader(); // Initial check
  }

  bindEvents() {
    window.addEventListener('scroll', () => { this.handleStickyHeader(); });
  }

  /**
   * @description Check if the user has scrolled past the header. If they have
   * add the is-sticky class.
   */
  handleStickyHeader() {
    let offsetTop = window.pageYOffset;
    let headerHeight = this.elHeader?.getBoundingClientRect().height || 0;;
    let headerOffset = this.elHeader.offsetTop;
    let threshold = headerHeight + headerOffset;

    if (offsetTop > threshold) {
      this.elHeader.classList.add('is-sticky');
    } else {
      this.elHeader.classList.remove('is-sticky');
    }

  }

  /**
   * @description Adds a top margin to the content pane below.
   */
  addMarginBelow() {
    let headerHeight = Helper.getHeight(this.elHeader);
    let isDNNEditState = document.body.classList.contains('dnnEditState');

    if (this.elHeader.dataset.marginBelow && !isDNNEditState) {

      if (this.elBanner) { this.elBanner.style.marginTop = headerHeight + 'px'; }
      if (this.elInnerBanner) { this.elInnerBanner.style.marginTop = headerHeight + 'px'; }
      
    }
  }

  debug() {
    if (debug) {
      console.groupCollapsed('%c Header', 'color: #bada55');
      console.log(this);
      console.groupEnd();
    }
  }
}